import { render, staticRenderFns } from "./MissingStatus.vue?vue&type=template&id=53da95d5&"
import script from "./MissingStatus.vue?vue&type=script&lang=js&"
export * from "./MissingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports